export default __webpack_public_path__ + "static/media/hero-desktop.4effd667.png";